import React, { useCallback, useEffect } from 'react'
import { LightBulbIcon } from '@heroicons/react/outline'
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil'
import { authenticated } from '../../recoil/auth'
import { quizCurrentPage, quizData, quizLoading } from '../../recoil/quiz'
import { contentInput, contentMessage } from '../../recoil/content'
import { domainWeb } from '../../config/constants'
import axios from 'axios'
import { Link } from 'react-router-dom'
import WaitingText from '../WaitingText'
import Pagination from '../Pagination'

const QuizzesInput = (props) => {
    const auth = useRecoilValue(authenticated);
    const [loading, setLoading] = useRecoilState(quizLoading);
    const [quiz, setQuiz] = useRecoilState(quizData);
    const setMessage = useSetRecoilState(contentMessage);
    const [input, setInput] = useRecoilState(contentInput);
    const [currentPage, setCurrentPage] = useRecoilState(quizCurrentPage);

    const changeQuizzes = (quiz) => {
        let newInput = {...input};
        newInput.quizzes = Object.assign([], newInput.quizzes);
        if (newInput.quizzes.includes(quiz)) {
            let i = newInput.quizzes.indexOf(quiz);
            newInput.quizzes.splice(i, 1);
        } else {
            newInput.quizzes.push(quiz);
        }
        setInput(newInput);
    };

    const getQuizData = useCallback(async () => {
        setLoading(true);
        setMessage({});
        try {
            let url = `${domainWeb}/quizzes?page=${currentPage}`;
            let response = await axios.get(url, {
                headers: {
                    'Content-Type': 'application/json', 
                    'Accept': 'application/json', 
                    'Authorization': 'Bearer ' + auth.token
                }
            });
            setQuiz(response.data);
            setLoading(false);
        } catch (error) {
            console.error(error);
            setMessage({
                success: false,
                text: error,
            });
            setLoading(false);
        }
    }, [auth.token, currentPage, setLoading, setMessage, setQuiz]);

    const loadQuiz = () => {
        if (loading || quiz.data === undefined) {
            return <WaitingText />;
        }
        if (quiz.data.length === 0) {
            return <div className="italic text-slate-500">Tidak ada data kuis. Tambahkan soal kuis di menu <Link to="/quizzes" className="text-blue-500 hover:text-blue-600">Kuis</Link>.</div>;
        }
        return (
            <div className="flex flex-col flex-1 gap-2">
                <div className="flex justify-between ">
                    <span className="font-semibold">Kuis</span>
                    <span className="pr-3 font-semibold">Pilih</span>
                </div>
                {
                    quiz.data.map((item, i) => (
                        <div key={i} className="flex items-center justify-between gap-3 px-3 py-2 rounded-lg hover:bg-slate-100">
                            <span className="flex-1 cursor-pointer overflow-clip hover:text-blue-600" onClick={() => props.clickQuiz(item)}>
                                <p className="truncate w-96">
                                    {item.question}
                                </p>
                            </span>
                            <input type="checkbox" onChange={e => changeQuizzes(e.target.value)} checked={input.quizzes.includes(item.id)} value={item.id} className="w-6 h-6 border-0 rounded-lg shadow cursor-pointer" />
                        </div>
                    ))
                }
                <div className="flex justify-end gap-5 px-8 py-3">
                    <Pagination currentPage={quiz.page} maxPage={quiz.max_page} changePage={changePage} />
                </div>
            </div>
        );
    };

    const changePage = (page) => {
        setCurrentPage(page);
      }

    useEffect(() => {
        getQuizData();
    }, [getQuizData]);

    return (
        <div className="flex flex-col items-start">
            <label className="text-sm">Soal Kuis <span className="text-xs text-red-500">{"(pilih minimal 1 soal)"}</span></label>
            <div className="flex items-start w-full gap-5 px-5 py-3 mt-2 rounded-lg bg-slate-50">
                <LightBulbIcon className="w-6 h-6" />
                {loadQuiz()}
            </div>
        </div>
    )
}

export default QuizzesInput